// extracted by mini-css-extract-plugin
export var formContainer = "_lm-0";
export var message = "_lm-1";